import { SvyIcon } from "@/indicators";
import styled from "@emotion/styled";
import type { StyledRadioProps } from "./SvyRadio.interface";
import { css, type Theme } from "@emotion/react";

const DEFAULT_COLOR = "primary" as const;

const mapAttributesFromProps = ({
    theme,
    checked,
    color = DEFAULT_COLOR,
    disabled,
}: { theme: Theme } & StyledRadioProps) => {
    const isDisabled = !!disabled;
    const isDefaultColor = color === DEFAULT_COLOR;

    const mainColor = theme.colors[color];
    const neutralColor = theme.colors.neutral;

    if (checked) {
        return {
            color: isDisabled ? neutralColor[300] : mainColor[500],
            hoveredColor: isDisabled ? neutralColor[300] : mainColor[600],
        };
    }

    return {
        color: isDefaultColor ? neutralColor[isDisabled ? 200 : 300] : mainColor[500],
        hoveredColor: isDisabled ? neutralColor[200] : mainColor[isDefaultColor ? 400 : 600],
    };
};

export const RadioGroupIndicatorIcon = styled(SvyIcon)<StyledRadioProps>`
    --svy-radio-size: 24px;

    ${(props) => {
        const { color, hoveredColor } = mapAttributesFromProps(props);
        return css`
            --svy-radio-color: ${color};
            --svy-radio-hover-color: ${hoveredColor};
        `;
    }};

    height: var(--svy-radio-size);
    width: var(--svy-radio-size);

    &:before {
        font-size: var(--svy-radio-size);
        color: var(--svy-radio-color);
    }

    &:hover {
        &:before {
            color: var(--svy-radio-hover-color);
        }
    }
`;
